import { lifecycle } from 'recompose';

import { fbq } from 'app/analytics/trackers/fbq';
import { COMPLETE_REGISTRATION } from 'app/analytics/constants/pixelConstants';

export default lifecycle({
  componentDidMount() {
    fbq(COMPLETE_REGISTRATION);
  },
});
